import L from 'leaflet';
import { agregarCapaAnimada, Z_RADAR } from './capaAnimada';

/**
 * Radar de precipitación — el detalle fino, donde alcanza.
 *
 * El dato es el mosaico NEXRAD del servicio meteorológico de Estados Unidos
 * (NOAA), servido en mosaicos por el Iowa Environmental Mesonet. Se eligió
 * después de descartar dos opciones que parecían mejores:
 *
 *  - RainViewer, que es lo que usa media internet, dice en sus términos que
 *    su API gratuita es "for personal and educational use only". Esto es un
 *    producto de paga con clientes adentro, así que no aplica.
 *  - El servicio propio de NOAA sí es de dominio público, pero se comprobó
 *    que RECORTA EN LA FRONTERA: sobre el mismo recuadro y al mismo minuto
 *    devolvía cero eco en territorio mexicano mientras este mosaico bajaba
 *    hasta los 25°N.
 *
 * El de Iowa State es dominio público —"may be used freely by anyone for any
 * lawful purpose"— y sí cubre el noreste de México, porque el radar de Del
 * Río, Texas, queda a 178 km de Sabinas y su alcance útil es de unos 230.
 *
 * DÓNDE NO SIRVE, que es la mitad importante: se midió la distancia al radar
 * más cercano para las zonas agrícolas del país y sólo Sabinas queda dentro.
 * Montemorelos está a 255 km, Cd. Victoria a 298, Hermosillo a 316, el Bajío
 * y Veracruz a más de 600. Para todos ésos esta capa se ve vacía aunque esté
 * lloviendo, y por eso existe la capa de satélite al lado: cubre el país
 * entero, con menos detalle, pero nunca deja a un cliente con un mapa mudo.
 *
 * Además, a 178 km el haz ya viaja unos 3 km sobre el suelo, así que una
 * llovizna baja se le escapa. Esto sirve para "viene una celda", no como
 * pluviómetro — ese número lo da la estación en campo.
 */

/** Minutos hacia atrás de cada cuadro. El 0 es el más reciente. */
const CUADROS = [50, 40, 30, 20, 10, 0];

/**
 * Transparencia de la lluvia sobre el fondo.
 *
 * Ni opaca ni fantasma: a 0.75 se distingue el color del eco y al mismo
 * tiempo se sigue viendo el terreno —y los sensores— por debajo.
 */
const OPACIDAD = 0.75;

/**
 * Hasta qué nivel existe dato real.
 *
 * El radar tiene resolución de alrededor de un kilómetro. El nivel 11 ya son
 * ~67 m por pixel, o sea que de ahí en adelante sólo se estaría estirando lo
 * mismo. Sin este tope, acercarse a un lote —los mapas llegan al 21— dispara
 * cientos de peticiones de mosaicos que no aportan un solo dato nuevo.
 */
const ZOOM_NATIVO_MAX = 11;

const plantilla = (minutos: number) =>
  `https://mesonet.agron.iastate.edu/cache/tile.py/1.0.0/nexrad-n0q-900913${
    minutos ? `-m${String(minutos).padStart(2, '0')}m` : ''
  }/{z}/{x}/{y}.png`;

export function agregarCapaRadar(
  map: L.Map,
  etiqueta: string,
  textoHora: (hora: string) => string,
): () => void {
  return agregarCapaAnimada(map, {
    cuadros: CUADROS,
    urlDe: plantilla,
    etiqueta,
    textoHora,
    opacidad: OPACIDAD,
    maxNativeZoom: ZOOM_NATIVO_MAX,
    zIndex: Z_RADAR,
    atribucion: 'Radar: NOAA NEXRAD / Iowa State Mesonet',
    preferencia: 'mapa_radar',
    // Encendido por omisión: los mosaicos sin lluvia son transparentes, así
    // que en un día despejado no estorba nada, y el día que sí importa la
    // información ya está en pantalla sin que nadie la haya ido a buscar.
    porOmision: true,
  });
}
